const filesList = {
    "office": (
        "Name       Date\n" +
            "abc.txt    2045-02-15\n" +
            "bcd.txt    2045-05-24\n" +
            "readme.md  2045-04-30\n"
    ).replace(/\x20\x20/g, "     "),
    "empty": "Host shell is empty."
}
export default {
    list: {
        execute(cmdParam, gamestate) {
            gamestate.triedList = true;
            let list = gamestate.nodes[gamestate.currentNode].files.map(x => x.name).join("\n");
            if (!list) {
                list = filesList.empty;
            }
            return [{
                lines: [list],
                startAt: 1000
            }];

        }
    }
};